export const shouldForceLogoutOnAuthError = (error: unknown): boolean => {
  const message = error instanceof Error ? error.message : String(error || '');
  const normalized = message.toLowerCase();

  return (
    normalized.includes('session expired') ||
    normalized.includes('invalid session') ||
    normalized.includes('missing session') ||
    normalized.includes('please log in again') ||
    (normalized.includes('401') && normalized.includes('session'))
  );
};
